import { Button, Chip } from '@mui/material';
import React from 'react';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import dayjs from 'dayjs';
import ToolTip from '../../../../components/ToolTip/ToolTip';

export default function GetColumns(head, setOpen) {
  const StatusGenerator = (value) => {
    let status = { label: 'Pending', color: 'warning' };
    const statusId = value;
    if (statusId === 1) {
      status.label = 'Approved';
      status.color = 'success';
    } else if (statusId === 2) {
      status.label = 'Rejected';
      status.color = 'error';
    }

    return status;
  };
  return [
    {
      field: 'slNo',
      headerName: 'Sl.No',
      width: 90,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'createdByName',
      headerName: 'Employee Name',
      width: 300,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'req_created_at',
      headerName: 'Requested Date',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      valueGetter: ({ value }) => dayjs(value).format('YYYY-DD-MM'),
    },
    {
      field: 'leave_name',
      headerName: 'Type',
      headerAlign: 'center',
      width: 130,
      align: 'center',
      valueGetter: ({ value }) => value ?? 'Attendance',
    },
    {
      field: 'reg_date',
      headerName: 'Worked Day',
      width: 140,
      align: 'center',
      headerAlign: 'center',
    },
    ...(head
      ? [
          {
            field: 'usertype',
            headerName: 'Designation',
            width: 300,
            align: 'center',
            headerAlign: 'center',
          },
        ]
      : [
          {
            field: 'actual',
            headerName: 'Old ( Hours )',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            valueGetter: ({ value }) => value.workingHours,
          },
          {
            field: 'planned',
            headerName: 'New ( Hours )',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            valueGetter: ({ value }) => value.workingHours,
          },
          {
            field: 'attendanceStatusOld',
            headerName: 'Old ( Status )',
            width: 150,
            align: 'center',
            headerAlign: 'center',
          },
          {
            field: 'attendanceStatusNew',
            headerName: 'New ( Status )',
            width: 150,
            align: 'center',
            headerAlign: 'center',
          },
        ]),

    {
      field: 'fromDate',
      headerName: 'From Date',
      width: 130,
      align: 'center',
      headerAlign: 'center',
      valueGetter: ({ row, value }) => (row?.req_leave_id ? value : 'N/A'),
    },
    {
      field: 'toDate',
      headerName: 'To Date',
      width: 130,
      align: 'center',
      headerAlign: 'center',
      valueGetter: ({ row, value }) => (row?.req_leave_id ? value : 'N/A'),
    },

    {
      field: 'reg_check_in',
      headerName: 'Check In',
      headerAlign: 'center',
      width: 130,
      align: 'center',
      valueGetter: ({ value }) => (value ? dayjs(value, 'HH:mm').format('hh:mm A') : 'N/A'),
    },
    {
      field: 'reg_check_out',
      headerName: 'Check Out',
      headerAlign: 'center',
      width: 130,
      align: 'center',
      valueGetter: ({ value }) => (value ? dayjs(value, 'HH:mm').format('hh:mm A') : 'N/A'),
    },
    {
      field: 'reg_reason',
      headerName: 'Reason',
      width: 300,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ value }) => <ToolTip expand={value} content={value} />,
    },

    ...(head
      ? [
          {
            field: 'document',
            headerName: 'Document',
            headerAlign: 'center',
            width: 100,
            align: 'center',
            renderCell: ({ row: { attachments } }) => {
              return attachments[0] ? (
                <a
                  href={`${process.env.REACT_APP_API_URL}uploads/${attachments[0]}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button startIcon={<RemoveRedEyeIcon />}>view</Button>
                </a>
              ) : (
                ''
              );
            },
          },
        ]
      : []),
    {
      field: 'hodStatus',
      headerName: 'Approval Status',
      headerAlign: 'center',
      width: 160,
      align: 'center',
      renderCell: ({ value }) => {
        const status = StatusGenerator(value);
        return <Chip label={status.label} variant="outlined" color={status.color} />;
      },
    },
    {
      field: 'hrStatus',
      headerName: 'HR Approval Status',
      headerAlign: 'center',
      width: 160,
      align: 'center',
      renderCell: ({ value }) => {
        const status = StatusGenerator(value);
        return <Chip label={status.label} variant="outlined" color={status.color} />;
      },
    },
    ...(!head
      ? [
          {
            field: 'Delete',
            headerName: 'Action',
            headerAlign: 'center',
            width: 160,
            align: 'center',
            renderCell: ({ row: { id, createdByName, slNo, hodStatus } }) => {
              return (
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setOpen({ id, createdByName, slNo })}
                  disabled={hodStatus}
                >
                  Delete
                </Button>
              );
            },
          },
        ]
      : []),
  ];
}
